import { call, options, params } from './helpers';

// Get all PM Schedules
export const getPMSchedules = (payload) =>
	call(`/beta/service-schedules${params(payload)}`);

// Get single PM Schedule
export const getPMSchedule = ({ id }) => call(`/beta/service-schedules/${id}`);

// Create new PM Schedule
export const createPMSchedule = (payload) =>
	call(`/beta/service-schedules`, options(payload, 'POST'));

// Update PM Schedule
export const updatePMSchedule = ({ id, ...payload }) =>
	call(`/beta/service-schedules/${id}`, options(payload, 'PUT'));

// Delete PM Schedule
export const deletePMSchedule = ({ id }) =>
	call(`/beta/service-schedules/${id}`, options(null, 'DELETE'));

// Get PM Schedule calendar data
export const getPMScheduleCalendar = (payload) =>
	call(`/beta/service-schedules/calendar${params(payload)}`);

// Add asset to PM Schedule
export const addPMScheduleAsset = ({ id, assetId, notes }) =>
	call(`/beta/service-schedules/${id}/assets`, options({ assetId, notes }, 'POST'));

// Remove asset from PM Schedule
export const removePMScheduleAsset = ({ id, assetId }) =>
	call(`/beta/service-schedules/${id}/assets/${assetId}`, options(null, 'DELETE'));

// Manually trigger PM generation (admin/testing)
export const generatePMWorkOrders = () =>
	call(`/beta/service-schedules/generate`, options(null, 'POST'));

// Generate work order for a specific schedule immediately (skip lead time)
export const generateWorkOrderNow = ({ id }) =>
	call(`/beta/service-schedules/${id}/generate-now`, options(null, 'POST'));
